import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 242px)"}
}
const _hoisted_2 = { style: {"overflow-y":"auto","height":"calc(100vh - 242px)"} }
const _hoisted_3 = { class: "flex flex-wrap gap-4 p-4" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex flex-col justify-between" }
const _hoisted_7 = { class: "text-5xl" }
const _hoisted_8 = { class: "flex justify-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "h-[120px]",
  align: "center"
}
const _hoisted_12 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_13 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "px-8 py-4 text-gray-500"
}
const _hoisted_16 = { class: "hidden md:block w-full" }
const _hoisted_17 = {
  key: 0,
  class: "px-8 py-0"
}
const _hoisted_18 = {
  key: 1,
  class: "px-8 py-4 text-gray-500"
}
const _hoisted_19 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-gray-500 ml-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_ImgLoading = _resolveComponent("ImgLoading")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_DepartmentLevelInventoryList = _resolveComponent("DepartmentLevelInventoryList")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
            return (_openBlock(), _createBlock(_component_el_card, {
              style: {"width":"100%","border":"2px solid #d1d5db","border-radius":"10px"},
              key: item.inventory_id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, _toDisplayString(item.organization_name), 1),
                  _createElementVNode("span", {
                    class: "material-symbols-outlined cursor-pointer",
                    onClick: ($event: any) => (_ctx.handleSetConstantButton(item))
                  }, " settings ", 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                  _createElementVNode("div", null, _toDisplayString(item.category_name), 1)
                ]),
                _createVNode(_component_el_row, { align: "middle" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 10,
                      justify: "center"
                    }, {
                      default: _withCtx(() => [
                        _cache[20] || (_cache[20] = _createElementVNode("div", null, "在庫合計", -1)),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.quantity), 1),
                        _createElementVNode("div", _hoisted_8, [
                          (!item.isExpand)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "material-symbols-outlined cursor-pointer",
                                onClick: ($event: any) => (_ctx.handleExpandButton(item))
                              }, [
                                _createVNode(_component_el_icon, { size: 16 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ArrowDown)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_9))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "material-symbols-outlined cursor-pointer",
                                onClick: ($event: any) => (_ctx.handleCollapseButton(item))
                              }, [
                                _createVNode(_component_el_icon, { size: 16 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ArrowUp)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_10))
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_col, { span: 14 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          (item.images)
                            ? (_openBlock(), _createBlock(_component_ImgLoading, {
                                key: 0,
                                modelValue: item.images,
                                "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                                class: "carousel-image"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                (item.isExpand)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (item.details && item.details.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_DepartmentLevelInventoryList, {
                              data: item.details,
                              loading: false,
                              "login-user-role": _ctx.loginUserRole,
                              "login-user-role-is-head": _ctx.loginUserRoleIsHead,
                              "search-department-id": undefined,
                              "is-standalone": false,
                              onEdit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit', $event))),
                              onDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', $event))),
                              onAlarm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('alarm', $event))),
                              onConstant: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('constant', $event))),
                              onExpand: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('nestedExpand', $event))),
                              onCollapse: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('collapse', $event))),
                              onQuantityUpdate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('quantityUpdate', $event))),
                              onTransferInventory: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('transferInventory', $event)))
                            }, null, 8, ["data", "login-user-role", "login-user-role-is-head"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, " データを読み込み中... "))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", _hoisted_16, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "tableRef",
        data: _ctx.data,
        height: "calc(100vh - 260px)",
        "row-key": "inventory_id",
        onExpandChange: _ctx.handleExpandChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "expand",
            label: "詳細",
            width: "80",
            align: "center"
          }, {
            default: _withCtx((props) => [
              (props.row.details && props.row.details.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_DepartmentLevelInventoryList, {
                      data: props.row.details,
                      loading: false,
                      "login-user-role": _ctx.loginUserRole,
                      "login-user-role-is-head": _ctx.loginUserRoleIsHead,
                      "search-department-id": undefined,
                      "is-standalone": false,
                      onEdit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('edit', $event))),
                      onDelete: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('delete', $event))),
                      onAlarm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('alarm', $event))),
                      onConstant: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('constant', $event))),
                      onExpand: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('nestedExpand', $event))),
                      onCollapse: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('collapse', $event))),
                      onQuantityUpdate: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('quantityUpdate', $event))),
                      onTransferInventory: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('transferInventory', $event)))
                    }, null, 8, ["data", "login-user-role", "login-user-role-is-head"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, " データを読み込み中... "))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "organization_name",
            label: "所属組織",
            width: "160"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSort('organization_name')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('organization_name')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'organization_name' }])
                    }, _toDisplayString(_ctx.getSortIcon('organization_name')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "category_name",
            label: "カテゴリ",
            width: "160"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSort('category_name')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('category_name')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'category_name' }])
                    }, _toDisplayString(_ctx.getSortIcon('category_name')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "material_name",
            label: "アイテム名",
            "min-width": "300"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSort('material_name')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('material_name')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'material_name' }])
                    }, _toDisplayString(_ctx.getSortIcon('material_name')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(scope.row.material_name), 1),
                _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                (scope.row.jancode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, " （" + _toDisplayString(scope.row.jancode) + "） ", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "quantity",
            label: "在庫数",
            width: "100",
            "header-align": "center",
            align: "right"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSort('quantity')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('quantity')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'quantity' }])
                    }, _toDisplayString(_ctx.getSortIcon('quantity')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.quantity), 1),
              (scope.row.material_unit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(scope.row.material_unit), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "100",
            "header-align": "center",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                style: {"background-color":"#b7b7b7"},
                text: "",
                bg: "",
                onClick: ($event: any) => (_ctx.handleSetConstantButton(scope.row))
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("span", null, "定数設定", -1)
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "画像",
            width: "52",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              (scope.row.images)
                ? (_openBlock(), _createBlock(_component_ImgLoading, {
                    key: 0,
                    modelValue: scope.row.images,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.images) = $event),
                    class: "thumbnail"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onExpandChange"])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ], 64))
}